import React, { useState } from 'react';
import {
  GP_FILTER_OPTIONS,
  filterGpClients,
  stateLabel,
  stateColor
} from '../constants/ecosystemProjects';
import './EcosystemPanels.css';

const GrowthPartnerProjects = ({ onNavigate }) => {
  const [filter, setFilter] = useState('en_alineacion');

  const clients = filterGpClients(filter);

  return (
    <div className="eco-panel">
      <header className="eco-panel-header">
        <h2>Proyectos Growth Partner</h2>
        <p>Tablero de clientes GP — Strutech en ejecución; resto del pipeline en alineación.</p>
      </header>

      <div className="eco-filter-row">
        {GP_FILTER_OPTIONS.map((opt) => (
          <button
            key={opt.id}
            type="button"
            className={`eco-filter-btn${filter === opt.id ? ' is-active' : ''}`}
            onClick={() => setFilter(opt.id)}
          >
            {opt.label}
          </button>
        ))}
      </div>

      <div className="eco-card-grid">
        {clients.map((c) => (
          <article key={c.id} className="eco-card">
            <div className="eco-card-top">
              <h3>{c.name}</h3>
              <span
                className="eco-state-pill"
                style={{ backgroundColor: stateColor(c.gpState), color: '#fff' }}
              >
                {stateLabel(c.gpState)}
              </span>
            </div>
            <p className="eco-card-sector">{c.sector}</p>
            <p className="eco-card-phase">
              <strong>Fase:</strong> {c.gpPhase}
            </p>
            {c.alsoIn ? (
              <p className="eco-card-meta">
                <i className="fas fa-link" aria-hidden /> También en: {c.alsoIn}
              </p>
            ) : null}
            {c.notes ? <p className="eco-card-notes">{c.notes}</p> : null}
            <div className="eco-card-links">
              {c.url ? (
                <a href={c.url} target="_blank" rel="noopener noreferrer">
                  Sitio web
                </a>
              ) : null}
              {c.id === 'kaaba' && typeof onNavigate === 'function' ? (
                <button
                  type="button"
                  className="eco-link-btn eco-link-btn--inline"
                  onClick={() => onNavigate('canal-tienda', '')}
                >
                  Canal tienda
                </button>
              ) : null}
              {c.doc ? (
                <span className="eco-doc-ref" title={c.doc}>
                  Doc: {c.doc}
                </span>
              ) : null}
              {c.pdf ? (
                <span className="eco-doc-ref" title={c.pdf}>
                  PDF: {c.pdf}
                </span>
              ) : null}
            </div>
          </article>
        ))}
      </div>

      {clients.length === 0 ? (
        <p className="eco-empty">No hay clientes en este filtro.</p>
      ) : null}
    </div>
  );
};

export default GrowthPartnerProjects;
